<script>
  import { beforeUpdate } from "svelte";
  import { dialogStore, headerDisplayStore } from "../stores/General";
  import { remove } from "../api";
  import CustomIcon from "../components/CustomIcon.svelte";
  const mapKeys = {
    campaign: {
      name: "name",
      id: "campaign_id",
      label: "Campaign",
    },
    topper: {
      name: "title",
      id: "topper_id",
      label: "Video Topper",
    },
    blacklist: {
      id: "id",
      name: "adomain",
      label: "Adomain Black-list",
    },
    "iab-blacklist": {
      id: "id",
      name: "iab_category_id",
      label: "IAB Black-List",
    },
  };
  let keys = mapKeys.default;

  beforeUpdate(() => {
    keys = mapKeys[$dialogStore.module] || keys;
  });

  function closeDialog() {
    if (!dialogStore.loading) dialogStore.close();
  }
  function deleteHandler() {
    dialogStore.update({ loading: true });
    remove(
      $dialogStore.module,
      $dialogStore.data.map((v) => v[keys.id])
    )
      .then(() => {
        headerDisplayStore.ShowNotification({
          title: "Success",
          subtitle: `${keys.label}${
            $dialogStore.data.length > 1 ? "s" : ""
          } deleted successfully`,
        });
        $dialogStore.function();
        dialogStore.close();
      })
      .catch((error) => {
        dialogStore.update({ loading: false });
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }
</script>

<div>
  <button
    class="border-0 hidden"
    on:click={(e) => {
      e.preventDefault();
      dialogStore.open();
    }}
  >
    <slot name="button" />
  </button>

  {#if $dialogStore.dialogOpen}
    <div
      class="fixed z-100 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        />

        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true">&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-lg px-6 pt-5 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-690 sm:w-full sm:p-6"
        >
          <div class="block absolute top-5 right-5 z-40 ">
            <div
              type="button"
              class="hover:text-gray-500 border-transparent cursor-pointer"
              on:click={closeDialog}
            >
              <span class="sr-only">Close</span>

              <CustomIcon width="18" height="18" name="close_dialog" />
            </div>
          </div>
          <div>
            <h3 class="text-center mb-3 font-bold">{$dialogStore.title}</h3>
            <slot name="body">
              {#each $dialogStore.data as item}
                <li>{item[keys.name]}</li>
              {/each}
            </slot>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              on:click={() => {
                deleteHandler();
              }}
              disabled={$dialogStore.loading}
              type="button"
              class="inline-flex px-4 py-2 justify-center ml-6 rounded-md border border-gray-300 bg-yellow-500 text-sm font-medium text-white hover:bg-yellow-400 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
            >
              {#if $dialogStore.loading}
                <span class="">Pending...</span>
              {:else}
                <span>OK</span>
              {/if}
            </button>
            <button
              disabled={$dialogStore.loading}
              type="button"
              on:click={closeDialog}
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>
